<template style="height: 100%;">
  <div class="ExmCon">
    <el-dialog title="报告权限审批"  :visible.sync="dialogTableVisible"  width="38%" >
      <table style="border-radius: 18px; width: 100%">
        <tr style="height: 30px;">
          <td class="td_left"> {{ $t('original.languages207') }}：</td>
          <td class="td_right">{{ Information.StuName }}</td>
        </tr>
        <tr style="height: 30px;">
          <td class="td_left">{{ $t('original.languages225') }}：</td>
          <td class="td_right">{{ Information.ConsultName }}</td>
        </tr>
        <tr style="height: 30px;">
          <td class="td_left">{{ $t('original.languages185') }}：</td>
          <td class="td_right">{{ Information.ApplyName }}</td>
        </tr>
        <tr style="height: 30px;">
          <td class="td_left">咨询时间：</td>
          <td class="td_right">{{ Information.ConsultTime }}</td>
        </tr>
        <tr style="height: 30px;">
          <td class="td_left">{{ $t('original.languages213') }}：</td>
          <td class="td_right"> {{ Information.ApplyReason == "" ? "未填写原因" : Information.ApplyReason  }}
          </td>
        </tr>
        <tr style="height: 30px;">
          <td class="td_left">{{ $t('original.languages113') }}：</td>
          <td class="td_right">{{ Information.ConsultName }}</td>
        </tr>
      </table>
      <table style="width:100%">
        <tr style="height: 30px;">
          <td class="td_left">{{ $t('original.languages190') }}：</td>
          <td class="check-remark-blue" v-if="Information.ApplySstatus == 0">
            {{ $t('original.languages200') }}
          </td>
          <td  class="check-remark-green"  v-else-if="Information.ApplySstatus == 1" >
            {{ $t('original.languages203') }}
          </td>
          <td  class="check-remark-red"  v-else-if="Information.ApplySstatus == 2" >
            {{ $t('original.languages204') }}
          </td>
          <td class="check-remark-gray" v-else> {{ $t('original.languages205') }}</td>
        </tr>
        <tr style="height: 30px;" v-if="Information.ApplySstatus == 2 && Information.Isshow">
          <td class="td_left"> 拒绝原因</td>
          <td class="td_right">{{ Information.RefuseReason }}</td>
        </tr>
        <tr style="height: 30px;"
          v-if=" (Information.ApplySstatus == 1 || Information.ApplySstatus == 2) &&  Information.Isshow">
          <td class="td_left">审批人</td>
          <td class="td_right">{{ Information.ApproverName }}</td>
        </tr>
        <tr style="height: 30px;" v-if="(Information.ApplySstatus == 1 || Information.ApplySstatus == 2) &&   Information.Isshow  " >
          <td class="td_left"> {{ $t('original.languages193') }}</td>
          <td class="td_right">{{ Information.SubmissionTime }}</td>
        </tr>
        <tr style="height: 30px;" v-if="Information.ApplySstatus == 0">
          <td class="td_left"> {{ $t('original.languages194') }}</td>
          <td class="td_right">
            <el-input :placeholder="$t('original.languages194')" type="textarea" v-model="Information.RefuseReason"></el-input>
          </td>
        </tr>
      </table>
      <div  class="buttons" style="width: 100%" v-if="Information.ApplySstatus == 0">
        <el-button type="primary" @click="UpdateApplySstatus((Information.ApplySstatus = 2),Information.ConsultApplyID)">
           {{ $t('original.languages195') }}
        </el-button>
        <el-button type="primary" @click="UpdateApplySstatus((Information.ApplySstatus = 1),Information.ConsultApplyID)">
           {{ $t('original.languages196') }}
        </el-button>
      </div>
    </el-dialog>
    <el-tabs type="border-card" class="list-cnt">
      <el-tab-pane :label="$t('original.languages197')">
        <span slot="label">{{ $t('original.languages197') }}</span>
        <el-button :disabled='spcinu' type="primary" @click="batchfun('1','1')">选中同意</el-button>
        <el-button :disabled='spcinu' type="primary" @click="batchfun('-1','1')">选中拒绝</el-button>
        <el-button :disabled='spcinu' type="success" @click="batchfun('1','2')">全部同意</el-button>
        <el-button :disabled='spcinu' type="danger" @click="batchfun('-1','2')">全部拒绝</el-button>
        <el-table :data="UndoTableData" v-loading="IsDataLoad" :element-loading-text="$t('original.languages22')" style="margin-top:15px" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column :label="$t('original.The_serial_number')" width="100px">
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="StuName" :label="$t('original.languages207')"></el-table-column>
          <el-table-column prop="ConsultName" :label="$t('original.languages225')"></el-table-column>
          <el-table-column prop="ConsultTheme" :label="$t('original.languages208')"></el-table-column>
          <el-table-column prop="ApplyName" :label="$t('original.languages185')"></el-table-column>
          <el-table-column prop="ApplyReason" :label="$t('original.languages213')"></el-table-column>
          <el-table-column prop="SubmissionTime" :label="$t('original.languages217')"></el-table-column>
          <el-table-column :label="$t('original.languages190')" width="100">
            <template>
              <span class="state-blue" style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;"> {{ $t('original.languages200') }} </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.languages49')" width="100" align="center">
            <template slot-scope="scope">
              <span class="option-blue copy_Button" @click="handleCheck(scope.row);
              Information.Isshow = false;">
                 {{ $t('original.languages201') }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize"  layout="total, prev, pager, next" :total="UndoCount" v-if="UndoCount > 0"></el-pagination>
      </el-tab-pane>
      <el-tab-pane :label="$t('original.languages202')">
        <el-table :data="DoTableData" v-loading="IsDataLoad" :element-loading-text="$t('original.languages22')">
          <el-table-column :label="$t('original.The_serial_number')" width="100px">
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="StuName" :label="$t('original.languages207')"></el-table-column>
          <el-table-column prop="ConsultName" :label="$t('original.languages225')"></el-table-column>
          <el-table-column prop="ConsultTheme" :label="$t('original.languages208')"></el-table-column>
          <el-table-column prop="ApplyName" :label="$t('original.languages185')"></el-table-column>
          <el-table-column prop="ApplyReason" :label="$t('original.languages213')"></el-table-column>
          <el-table-column prop="SubmissionTime" :label="$t('original.languages217')"></el-table-column>
          <el-table-column :label="$t('original.languages214')" width="100">
            <template slot-scope="scope">
              <span class="state-green"  style="color: #fff; background-color: rgba(21, 191, 109, 1);padding: 8px;border-radius: 12px;" v-if="scope.row.ApplySstatus == 1">
                 {{ $t('original.languages203') }}
              </span>
              <span class="state-red" style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;" v-else-if="scope.row.ApplySstatus == 2">
                 {{ $t('original.languages204') }}
              </span>
              <span class="state-gray" v-else> {{ $t('original.languages205') }} </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.languages49')" width="100">
            <template slot-scope="scope">
              <span class="option-blue copy_Button" @click="handleCheck(scope.row); Information.Isshow = true;">
                 {{ $t('original.languages174') }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" layout="total, prev, pager, next" :total="DoCount" v-if="DoCount > 0"></el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      spcinu:false,
      IsDataLoad: true,
      dialogTableVisible: false, //打开详情框
      pageSize: 10,
      pageIndex: 1,
      UndoTableData: [],
      DoTableData: [],
      UndoCount: -1,
      DoCount: -1,
      appointmentList: [],
      Information: {
        ConsultApplyID: "",
        StuName: "",
        ConsultName: "",
        ApplyName: "",
        ConsultTheme: "",
        SubmissionTime: "",
        ApplySstatus: "",
        ApplyReason: "",
        RealName: "",
        ApproverTime: "",
        ApproverName: "",
        RefuseReason: "",
        Isshow: false,
        ConsultTime: "",
        DeleteKeys:[]
      },
    };
  },
  created() {
    this.GetData();
  },
  methods: {
    batchfun(val,type){
      if(type == 1){
        this.spcinu = true;
        if(this.DeleteKeys.length > 0){
          this.$Http_Post('management/consultsubscribe/batchhandleblacklist', {handleFlag: val,ids:this.DeleteKeys}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.spcinu = false;
              this.Global.request_successful(res.Message);
              window.location.reload();
            } else {
              this.spcinu = false;
              this.$message.error(res.Message);
            }
          })
        }else{
          alert('请选择选项！');
        }
      }else if(type == 2){//全部
        this.spcinu = true;
        this.$Http_Post('/management/consultsubscribe/batchhandlereport', {handleFlag: val}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.spcinu = false;
            this.Global.request_successful(res.Message);
            this.GetData();
          } else {
            this.spcinu = false;
            this.$message.error(res.Message);
          }
        })
      }
    },
    // 全选
    handleSelectionChange(e){
      this.DeleteKeys = [];
      for(let item of e){
        this.DeleteKeys.push(item.ConsultApplyID);
      }
    },
    GetData() {
      this.IsDataLoad = true;
      let _this = this;
      this.$Http_Post("ConsultSubscribe/GetAllExamineConsultReport", {pageSize: this.pageSize,pageIndex: this.pageIndex}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.UndoTableData = res.Data.UndoTableData;
          _this.DoTableData = res.Data.DoTableData;
          _this.UndoCount = res.Data.UndoCount;
          _this.DoCount = res.Data.DoCount;
          _this.IsDataLoad = false;
          // _this.$parent.RefreshCheckReportCount(_this.UndoCount);
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetData();
    },
    handleCheck(obj) {
      let _this = this;
      _this.dialogTableVisible = true;
      _this.Information.ConsultApplyID = obj.ConsultApplyID;
      _this.Information.StuName = obj.StuName;
      _this.Information.ConsultName = obj.ConsultName;
      _this.Information.ConsultTheme = obj.ConsultTheme;
      _this.Information.SubmissionTime = obj.SubmissionTime;
      _this.Information.ApplySstatus = obj.ApplySstatus;
      _this.Information.UserName = obj.UserName;
      _this.Information.ApplyReason = obj.ApplyReason;
      _this.Information.Assessment = obj.Assessment;
      _this.Information.ApplyName = obj.ApplyName;
      _this.Information.ApproverTime = obj.ApproverTime;
      _this.Information.RefuseReason = obj.RefuseReason;
      _this.Information.ApproverName = obj.ApproverName;
      _this.Information.ConsultTime = obj.ConsultTime;
    },
    selectappointment(starTime, endTime, UserAccount) {
      this.$Http_Post("ConsultSubscribe/GetLeaveAppointment", {starTime: starTime,endTime: endTime,UserID: UserAccount}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.appointmentList = res.Data;
        } else {
          this.$notify.closeAll();
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.data.Message,
          });
        }
      });
    },
    UpdateApplySstatus(ApplySstatus, ConsultApplyID) {
      let RefuseReason = "";
      if (ApplySstatus == 2) {RefuseReason = this.Information.RefuseReason;}
      this.$Http_Post("ConsultSubscribe/UpdateExamineConsultReport", {ConsultApplyID: ConsultApplyID,RefuseReason: RefuseReason,ApplySstatus: ApplySstatus}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          if (ApplySstatus == 2) {
            this.$message({
              message: this.$t('original.languages204'),
              type: "success",
            });
          } else {
            this.$message({
              message: this.$t('original.languages203'),
              type: "success",
            });
          }
          this.GetData();
          this.dialogTableVisible = false;
          // this.$parent.RefreshCheckReportCount(-1);
        } else {
          this.$message.error(this.$t('original.languages206'));
        }
      });
    },
  },
};
</script>
<style>
.el-tabs {height: 100%;}
.list-cnt {height: 100%;}
.el-table--enable-row-transition .el-table__body td{text-align: center;}
</style>
